/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Panel, BlockChain, Spinner } from "vr-react-components";
import {
    getColorFromStatus,
    getIconFromStatus,
} from "../../widgets/TopologyWidget/Utils";
import Tooltip from "../../widgets/TopologyWidget/TopologyWidgetTooltip";
import BarPanelAux from "./BarPanelAux";
import { setIsPanelOpen } from "../../store/slice/roomSlices/delayAnalysisRoomSlice";
import { DELAY_ANALISYS_ROOM } from "../RoomNameConstants";

const DelayChain = ({ width, height }) => {
    const isPanelOpen = useSelector((state) => state[DELAY_ANALISYS_ROOM].isPanelOpen);
    const graph = useSelector((state) => state[DELAY_ANALISYS_ROOM].graph);
    const device = useSelector((state) => state.private.device);
    const canModify = useSelector((state) => state.private.device.canModify);

    const dispatch = useDispatch();

    const selectedJobId = isPanelOpen !== false ?
        graph[isPanelOpen].id : null;

    const handleTogglePanelOpen = (id) => {
        if (isPanelOpen === id) dispatch(setIsPanelOpen(false))
        else dispatch(setIsPanelOpen(id))
    }

    if (!graph) return <Spinner radius={0.5} />

    return (
        <>
            <BlockChain
                iconSelector={getIconFromStatus}
                colorSelector={getColorFromStatus}
                Tooltip={Tooltip}
                deviceData={device}
                data={graph}
                width={width}
                height={height / 5}
                clickHandler={handleTogglePanelOpen}
                aframeClasses={canModify ? "collidable" : ""}
                selected={isPanelOpen}
                animation={`property: position; autoplay: true; from: 0 0 0; to: 0 -1.6 0; dur:500; enabled: ${isPanelOpen !== false}`}
                animation__closePanel={`property: position; autoplay: true; to: 0 0 0; dur:500; enabled: ${isPanelOpen === false}`}
            />
            {isPanelOpen !== false && (
                <Panel
                    width={width}
                    height={height}
                    panel
                    visible={false}
                    aframeClasses={canModify ? "collidable" : ""}
                    title={`Job: ${graph[isPanelOpen].job} | Status: ${graph[isPanelOpen].status} | Type: ${graph[isPanelOpen].type}`}
                    textSizeDecimal={90 / width}
                    animation="property: visible; autoplay: true; to: true; dur: 500"
                    position={`0 ${height / 5} ${-height / 5}`}
                >
                    <BarPanelAux
                        stateName="lastTenRunsChart"
                        jobID={selectedJobId}
                        title="Last 10 runs duration (in min)"
                        width={(width / 3) * 0.95}
                        height={height * 0.8}
                        position={`${-width / 2 + width / 6 + (width / 3) * 0.025} 0 0`}
                    />

                    <BarPanelAux
                        stateName="dataChartStartTime"
                        jobID={selectedJobId}
                        title="Job start time"
                        width={(width / 3) * 0.95}
                        height={height * 0.8}
                    />

                    <BarPanelAux
                        stateName="dataChartDuration"
                        jobID={selectedJobId}
                        title="Duration trend"
                        width={(width / 3) * 0.95}
                        height={height * 0.8}
                        position={`${width / 2 - width / 6 - (width / 3) * 0.025} 0 0`}
                    />
                </Panel>
            )}
        </>
    );
};

export default DelayChain